export default __webpack_public_path__ + "static/home-page-preview-section-bg-mob-9276dc1a150c3083db0b3ae2a29f3892.jpg";